import { Component, OnInit, Input } from '@angular/core';
import { Job } from '@model/entities/job';
import { StateService } from '@service/state.service';
import { UrlPrettifierService } from '@service/urlPrettifier/url-prettifier.service';
;

@Component({
  selector: 'app-job-related-items',
  templateUrl: './job-related-items.component.html',
  styleUrls: ['./job-related-items.component.scss']
})
export class JobRelatedItemsComponent implements OnInit {

  @Input() direction: 'vertical' | 'horizontal'
  @Input() title: string = ''
  @Input() items: Job[]

  public fxDirection: 'row' | 'column'
  public fxAlignment: string
  public flexValue: string = 'auto'

  constructor(
    private StateService: StateService
  ) { }

  ngOnInit() {
    if (this.direction == "vertical") {
      this.fxDirection = "column"
      this.fxAlignment = "center"
    } else {
      this.fxDirection = "row"
      this.fxAlignment = "space-between"
      this.flexValue = "25"
    }
  }

  public goToItem(job: Job) {
    this.StateService.goto(
      '/job/detail/' + job.id + '/' + UrlPrettifierService.prettyUrl(job.title)
    )
  }
}